import { render, staticRenderFns } from "./DatabaseBackup.vue?vue&type=template&id=6efd9644&scoped=true"
import script from "./DatabaseBackup.vue?vue&type=script&lang=js"
export * from "./DatabaseBackup.vue?vue&type=script&lang=js"
import style0 from "./DatabaseBackup.vue?vue&type=style&index=0&id=6efd9644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd9644",
  null
  
)

export default component.exports